import { IdName } from '../../shared/models/id-name';
import { ActivityColor } from '../../shared/enums/activity-color.enum';

interface IActivity {
  id: string;
  name: string;
}

export interface IActivityDropdown extends IActivity {
  isSailing: boolean;
  needsToBeConfirmed: boolean;
  color: number;
}

export interface IActivityResponse extends IActivity {
  readonly needsToBeConfirmed?: boolean;
  readonly isSailing?: boolean;
  readonly isSickness?: boolean;
  readonly dayFactor: number;
  readonly color: ActivityColor;
  readonly departments: IdName[];
  readonly departmentGroups: IdName[];
}
export type IActivityList = Omit<IActivityResponse, 'dayFactor'> | { readonly dayFactor: string };
export interface IActivityRequest extends IActivity {
  isConfirmedOnBoard: boolean;
  isSailing: boolean;
  isSickness: boolean;
  dayFactor: number;
  color: ActivityColor;
  departments: IdName[];
  departmentGroups: IdName[];
}

export function map(activityRequest: IActivityRequest): IActivityResponse {
  return <IActivityResponse>{
    id: activityRequest.id,
    name: activityRequest.name,
  };
}
